<template>
<div class="form">
  <div class="form__header">
    <h3>Обновить ученика</h3>
  </div>
  <div class="form__body">
    <Input 
      class="form__field" 
      v-model="formData.name" 
      label="Имя" 
      type="text" 
      id="student-name" 
      :required="true" 
    />

    <Input 
      class="form__field" 
      v-model="formData.email" 
      label="Email(логин)" 
      type="email" 
      id="student-email" 
      :required="true" 
    />

    <p class="form__field">
      <span>Дата рождения:</span>
      <date-picker 
        :format="'DD-MM-YYYY'" 
        v-model="formData.property.birth_date" 
        valueType="format" 
        :default-value="new Date('2010-01-01')"
        class="required"
        :class="{
          valid: formData.property.birth_date,
          invalid: !formData.property.birth_date,
        }"
      ></date-picker>
    </p>

    <Input 
      class="form__field" 
      v-model="formData.property.city" 
      label="Город" 
      type="text" 
      id="student-city" 
    />

    <Input 
      class="form__field" 
      v-model="formData.property.parent_name" 
      label="Имя родителя" 
      type="text" 
      id="parent-name" 
    />

    <Input 
      class="form__field" 
      v-model="formData.property.parent_phone" 
      label="Телефон" 
      type="text" 
      id="parent-phone" 
    />

    <Input 
      class="form__field" 
      v-model="formData.property.parent_mail" 
      label="Email родителя" 
      type="text" 
      id="parent-email" 
    />

    <p class="form__field">
      <span>Цели родителей:</span>
      <textarea rows="3" v-model="formData.property.parent_target"></textarea>
    </p>
  </div>

  <div class="form__footer">
    <SubmitButton :isValid="isValid" @submit="updateUser" text="Сохранить" />
  </div>

</div>
</template>

<script>
import { form_mix } from "../../../mixins/form_mix";

export default {
  mixins: [ form_mix ], 
  props: ['data'],
  inject: ['http'],
  name: "student_anketa",
  data() {
    return {
      formData: {},
      requiredKeys: ['name', 'email']
    }
  },  
  methods: {
    updateUser() {
      console.log(this.formData)
      this.http.post('onUpdateUserByTeacher', { user: this.formData})
        .then(() => {
          swal('Успешно!', "Анкета ученика отредактирована", "success");
          this.$emit('close-popup')
          this.$emit('update-student', this.formData)
        })
        .catch(e => swal('Что-то пошло не так', '' + e, 'error'));
    }   
  },
  created() {
    this.formData = Object.assign({}, this.data)
  }
}
</script>
